<nav class="flex flex-col"
	style="background-image: url('/images/marble_texture_dark.png'); background-size: cover; background-position: center; transition: width 0.2s ease; display: flex; flex-direction: column; height: 100%; min-height: 0;"
	[style.width]="collapsed ? '48px' : '96px'">

	<!-- Scrollable nav area -->
	<ul class="flex flex-col items-center flex-1 py-4 gap-2"
		style="min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: var(--color-gold-600) transparent;">

		<!-- Home -->
		@if (!isPillarReviewRequired) {
		<li class="w-full flex justify-center">
			<button (click)="navigate('/dashboard')"
				class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
				[style.width]="collapsed ? '36px' : '72px'"
				[style.height]="collapsed ? '36px' : '72px'"
				[style.background-color]="isActive('/dashboard') ? '#3a6090' : '#2a4a68'"
				[style.box-shadow]="buttonShadow('/dashboard')"
				(mouseenter)="onButtonEnter($event, '/dashboard')"
				(mouseleave)="onButtonLeave($event, '/dashboard')"
				(mousedown)="onButtonDown($event)"
				(mouseup)="onButtonUp($event)">
				<div class="absolute inset-0 flex items-center justify-center pointer-events-none">
					<img src="/images/laurel_overlay.png" class="laurel-inner w-full h-full object-contain transition-all duration-300"
						[style.opacity]="laurelOpacity('/dashboard')" />
				</div>
				<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/25 pointer-events-none"></div>
				<div class="relative z-10 flex flex-col items-center justify-center gap-1">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" [attr.stroke]="iconStroke('/dashboard')" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z"/><path d="M9 21V12h6v9"/></svg>
					@if (!collapsed) {
						<span ro-i18n eikey="nav.home" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.06em; color: var(--color-sandstone);">Home</span>
					}
				</div>
			</button>
		</li>
		} <!-- end !isPillarReviewRequired (Home) -->

		<!-- Proposals -->
		@if (!isPillarReviewRequired) {
		<li class="w-full flex justify-center">
			<button (click)="navigate('/proposals')"
				class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
				[style.width]="collapsed ? '36px' : '72px'"
				[style.height]="collapsed ? '36px' : '72px'"
				[style.background-color]="isActive('/proposals') ? '#3a6090' : '#2a4a68'"
				[style.box-shadow]="buttonShadow('/proposals')"
				(mouseenter)="onButtonEnter($event, '/proposals')"
				(mouseleave)="onButtonLeave($event, '/proposals')"
				(mousedown)="onButtonDown($event)"
				(mouseup)="onButtonUp($event)">
				<div class="absolute inset-0 flex items-center justify-center pointer-events-none">
					<img src="/images/laurel_overlay.png" class="laurel-inner w-full h-full object-contain transition-all duration-300"
						[style.opacity]="laurelOpacity('/proposals')" />
				</div>
				<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/25 pointer-events-none"></div>
				<div class="relative z-10 flex flex-col items-center justify-center gap-1">
					<img src="/images/scroll.svg" width="18" height="18" style="object-fit: contain;"
						[style.opacity]="isActive('/proposals') ? '1' : '0.9'" />
					@if (!collapsed) {
						<span ro-i18n eikey="nav.proposals" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.06em; color: var(--color-sandstone);">Home</span>
					}
				</div>
			</button>
		</li>
		} <!-- end !isPillarReviewRequired (Proposals) -->

		<!-- Deliberation -->
		@if (!isPillarReviewRequired) {
		<li class="w-full flex justify-center">
			<button (click)="navigate('/deliberation')"
				class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
				[style.width]="collapsed ? '36px' : '72px'"
				[style.height]="collapsed ? '36px' : '72px'"
				[style.background-color]="isActive('/deliberation') ? '#3a6090' : '#2a4a68'"
				[style.box-shadow]="buttonShadow('/deliberation')"
				(mouseenter)="onButtonEnter($event, '/deliberation')"
				(mouseleave)="onButtonLeave($event, '/deliberation')"
				(mousedown)="onButtonDown($event)"
				(mouseup)="onButtonUp($event)">
				<div class="absolute inset-0 flex items-center justify-center pointer-events-none">
					<img src="/images/laurel_overlay.png" class="laurel-inner w-full h-full object-contain transition-all duration-300"
						[style.opacity]="laurelOpacity('/deliberation')" />
				</div>
				<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/25 pointer-events-none"></div>
				<div class="relative z-10 flex flex-col items-center justify-center gap-1">
					<img src="/images/scales.svg" width="18" height="18" style="object-fit: contain;"
						[style.opacity]="isActive('/deliberation') ? '1' : '0.7'" />
					@if (!collapsed) {
						<span ro-i18n eikey="nav.deliberation" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.06em; color: var(--color-sandstone);">Deliberation</span>
					}
				</div>
			</button>
		</li>
		} <!-- end !isPillarReviewRequired (Deliberation) -->

		<!-- Pillars -->
		<li class="w-full flex justify-center">
			<button (click)="navigate('/pillars')"
				class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
				[style.width]="collapsed ? '36px' : '72px'"
				[style.height]="collapsed ? '36px' : '72px'"
				[style.background-color]="isActive('/pillars') ? '#3a6090' : '#2a4a68'"
				[style.box-shadow]="buttonShadow('/pillars')"
				(mouseenter)="onButtonEnter($event, '/pillars')"
				(mouseleave)="onButtonLeave($event, '/pillars')"
				(mousedown)="onButtonDown($event)"
				(mouseup)="onButtonUp($event)">
				<div class="absolute inset-0 flex items-center justify-center pointer-events-none">
					<img src="/images/laurel_overlay.png" class="laurel-inner w-full h-full object-contain transition-all duration-300"
						[style.opacity]="laurelOpacity('/pillars')" />
				</div>
				<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/25 pointer-events-none"></div>
				<div class="relative z-10 flex flex-col items-center justify-center gap-1">
					<img src="/images/pillar.svg" width="18" height="18" style="object-fit: contain;"
						[style.opacity]="isActive('/pillars') ? '1' : '0.7'" />
					@if (!collapsed) {
						<span ro-i18n eikey="nav.pillars" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.06em; color: var(--color-sandstone);">Pillars</span>
					}
				</div>
			</button>
		</li>


		<!-- Admin section — only visible to users with any admin access -->
		@if (hasAnyAdminAccess) {

			<!-- Gold divider separator -->
			<li class="w-full px-3 py-1" aria-hidden="true">
				<div style="height: 1px; background: linear-gradient(to right, transparent, var(--color-gold-500), transparent);"></div>
			</li>

			@if (!collapsed) {
				<li class="w-full flex justify-center">
					<span ro-i18n eikey="admin.administration" style="font-family: var(--font-family-display); font-size: 0.45rem; letter-spacing: 0.2em; color: var(--color-sandstone); opacity: 0.9; text-transform: uppercase;">Administration</span>
				</li>
			}

			@if (canConfig) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/config')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/config')"
						[style.box-shadow]="buttonShadow('/admin/config')"
						(mouseenter)="onButtonEnter($event, '/admin/config')"
						(mouseleave)="onButtonLeave($event, '/admin/config', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<circle cx="12" cy="12" r="3"/>
								<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.orgConfig" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Org Config</span>
							}
						</div>
					</button>
				</li>

				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/proposals')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/proposals')"
						[style.box-shadow]="buttonShadow('/admin/proposals')"
						(mouseenter)="onButtonEnter($event, '/admin/proposals')"
						(mouseleave)="onButtonLeave($event, '/admin/proposals', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
								<polyline points="14 2 14 8 20 8"/>
								<line x1="16" y1="13" x2="8" y2="13"/>
								<line x1="16" y1="17" x2="8" y2="17"/>
								<polyline points="10 9 9 9 8 9"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.proposalsConfig" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Proposals</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canPillarsAdmin) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/pillars')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/pillars')"
						[style.box-shadow]="buttonShadow('/admin/pillars')"
						(mouseenter)="onButtonEnter($event, '/admin/pillars')"
						(mouseleave)="onButtonLeave($event, '/admin/pillars', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<rect x="3" y="3" width="18" height="4" rx="1"/>
								<line x1="5" y1="7" x2="5" y2="21"/>
								<line x1="12" y1="7" x2="12" y2="21"/>
								<line x1="19" y1="7" x2="19" y2="21"/>
								<line x1="3" y1="21" x2="21" y2="21"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.pillars" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Pillars</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canMembers) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/members')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/members')"
						[style.box-shadow]="buttonShadow('/admin/members')"
						(mouseenter)="onButtonEnter($event, '/admin/members')"
						(mouseleave)="onButtonLeave($event, '/admin/members', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
								<circle cx="9" cy="7" r="4"/>
								<path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
								<path d="M16 3.13a4 4 0 0 1 0 7.75"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.members" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Members</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canIdeas) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/ideas')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/ideas')"
						[style.box-shadow]="buttonShadow('/admin/ideas')"
						(mouseenter)="onButtonEnter($event, '/admin/ideas')"
						(mouseleave)="onButtonLeave($event, '/admin/ideas', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<img src="/images/scroll.svg" width="18" height="18" style="object-fit: contain; opacity: 0.9;" />
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.ideas" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Proposals</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canPillarsAdmin) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/floor')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/floor')"
						[style.box-shadow]="buttonShadow('/admin/floor')"
						(mouseenter)="onButtonEnter($event, '/admin/floor')"
						(mouseleave)="onButtonLeave($event, '/admin/floor', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<rect x="9" y="2" width="6" height="8" rx="1"/>
								<path d="M6 10h12l1 4H5l1-4z"/>
								<line x1="12" y1="14" x2="12" y2="20"/>
								<line x1="8" y1="20" x2="16" y2="20"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.floor" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Floor</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canModeration) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/moderation')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/moderation')"
						[style.box-shadow]="buttonShadow('/admin/moderation')"
						(mouseenter)="onButtonEnter($event, '/admin/moderation')"
						(mouseleave)="onButtonLeave($event, '/admin/moderation', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<img src="/images/scales.svg" width="18" height="18" style="object-fit: contain; opacity: 0.9;" />
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.moderation" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Moderation</span>
							}
						</div>
					</button>
				</li>
			}

			@if (canReporting) {
				<li class="w-full flex justify-center">
					<button (click)="navigate('/admin/reports')"
						class="relative flex flex-col items-center justify-center rounded-lg overflow-hidden transition-all duration-300"
						[style.width]="collapsed ? '36px' : '72px'"
						[style.height]="collapsed ? '36px' : '72px'"
						[style.background-color]="adminButtonBg('/admin/reports')"
						[style.box-shadow]="buttonShadow('/admin/reports')"
						(mouseenter)="onButtonEnter($event, '/admin/reports')"
						(mouseleave)="onButtonLeave($event, '/admin/reports', true)"
						(mousedown)="onButtonDown($event)"
						(mouseup)="onButtonUp($event)">
						<div class="absolute inset-0 bg-gradient-to-b from-white/10 to-black/20 pointer-events-none"></div>
						<div class="relative z-10 flex flex-col items-center justify-center gap-1">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c8250" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
								<line x1="18" y1="20" x2="18" y2="10"/>
								<line x1="12" y1="20" x2="12" y2="4"/>
								<line x1="6" y1="20" x2="6" y2="14"/>
							</svg>
							@if (!collapsed) {
								<span ro-i18n eikey="admin.nav.reporting" style="font-family: var(--font-family-display); font-size: 0.55rem; letter-spacing: 0.04em; color: #6b5230;">Reporting</span>
							}
						</div>
					</button>
				</li>
			}

		} <!-- end hasAnyAdminAccess -->

	</ul>

	<!-- Gold divider -->
	<div style="height: 1px; background: linear-gradient(to right, transparent, var(--color-gold-500), transparent); margin: 0 12px;"></div>

	<!-- Collapse toggle -->
	<button (click)="toggle()"
		class="flex items-center justify-center w-full py-2 transition-all"
		style="color: var(--color-gold-400); opacity: 0.9; background-color: rgba(255,255,255,0.04);"
		onmouseover="this.style.opacity='1'; this.style.backgroundColor='rgba(255,255,255,0.10)'"
		onmouseout="this.style.opacity='0.9'; this.style.backgroundColor='rgba(255,255,255,0.04)'">
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
			@if (collapsed) {
				<polyline points="9 18 15 12 9 6"/>
			} @else {
				<polyline points="15 18 9 12 15 6"/>
			}
		</svg>
	</button>

</nav>
